/* FRATERNAL — frt-pdp.js. Gallery, size picker, size-guide drawer.
   The drawer's hidden-attribute guard lives in CSS (.drawer[hidden]{display:none}) because
   display:flex otherwise overrides the attribute and the drawer is never really hidden. */
(function () {
  var d = document;
  var root = d.querySelector('[data-frt-pdp]');
  if (!root) return;

  d.querySelectorAll('[data-frt-thumb]').forEach(function (t) {
    t.addEventListener('click', function () {
      var main = d.querySelector('.gal__main img');  // see main-product.liquid: no hyphenated Liquid filter args
      if (!main) return;
      // srcset wins over src, so it must be swapped (or dropped) too — swapping src alone left
      // the featured image on screen for every thumbnail (fixed 2026-10-21).
      var ss = t.getAttribute('data-frt-srcset');
      if (ss) main.srcset = ss; else main.removeAttribute('srcset');
      main.src = t.getAttribute('data-frt-src');
      d.querySelectorAll('[data-frt-thumb]').forEach(function (x) { x.classList.remove('is-active'); });
      t.classList.add('is-active');
    });
  });

  var atc = d.querySelector('[data-frt-atc]');
  d.querySelectorAll('[data-frt-size]').forEach(function (r) {
    r.addEventListener('change', function () {
      if (!r.checked) return;
      var lab = d.querySelector('[data-frt-size-label]');
      var vid = d.querySelector('[data-frt-variant-id]');
      var stk = d.querySelector('[data-frt-stock]');
      if (lab) lab.textContent = r.value;
      if (vid) vid.value = r.getAttribute('data-frt-variant');
      var avail = r.getAttribute('data-available') === 'true';
      if (atc) {
        atc.disabled = !avail;
        atc.textContent = avail ? atc.getAttribute('data-label') : 'SOLD OUT';
      }
      if (stk) stk.textContent = avail ? stk.getAttribute('data-in') : 'Sold out in this size';
      var pr = d.querySelector('[data-frt-price]');
      if (pr && r.getAttribute('data-frt-price')) pr.textContent = r.getAttribute('data-frt-price');
      carrySizeToColorways(r.value);
      carrySizeToSet(r.value);
    });
  });

  // Complete the set (2026-11-02): pick the same size on the matching piece when it stocks
  // it. Only the card on this page (root); the bag drawer has its own cards. The change
  // event lets frt-cart.js swap the card's SELECT SIZE label for ADD TO BAG.
  function carrySizeToSet(size) {
    var want = String(size).toLowerCase().trim();
    root.querySelectorAll('[data-frt-set]').forEach(function (card) {
      var hit = null;
      card.querySelectorAll('[data-frt-set-size]').forEach(function (i) {
        if (!i.disabled && i.getAttribute('data-frt-set-size') === want) hit = i;
      });
      if (!hit || hit.checked) return;
      hit.checked = true;
      hit.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }

  // Colour swatches link to SIBLING PRODUCTS (each Fraternal colourway is its own product),
  // so carry the picked size across: point each swatch at that product's variant of the same
  // size. A colourway that does not stock the size keeps its plain URL rather than landing the
  // shopper on an arbitrary variant.
  function carrySizeToColorways(size) {
    d.querySelectorAll('[data-frt-cw]').forEach(function (a) {
      var base = a.getAttribute('data-frt-cw-url');
      var map = a.getAttribute('data-frt-cw-sizes') || '';
      var id = '';
      map.split(';').forEach(function (pair) {
        var i = pair.indexOf('=');
        if (i > 0 && pair.slice(0, i) === size) id = pair.slice(i + 1);
      });
      a.href = id ? base + '?variant=' + id : base;
    });
  }
  var checkedSize = d.querySelector('[data-frt-size]:checked');
  if (checkedSize) carrySizeToColorways(checkedSize.value);

  // sticky ATC: show only after the real button leaves the viewport; proxy clicks to it
  var bar = d.querySelector('[data-frt-sticky]');
  if (bar && atc && 'IntersectionObserver' in window) {
    var proxy = bar.querySelector('[data-frt-sticky-add]');
    new IntersectionObserver(function (entries) {
      var gone = !entries[0].isIntersecting;
      if (gone) { bar.hidden = false; requestAnimationFrame(function () { bar.classList.add('is-in'); }); }
      else { bar.classList.remove('is-in'); setTimeout(function () { if (!bar.classList.contains('is-in')) bar.hidden = true; }, 250); }
    }, { rootMargin: '0px 0px -40px 0px' }).observe(atc);

    proxy.addEventListener('click', function () { atc.click(); });

    // PREVIEW ONLY: Shopify's draft preview bar is pinned to the bottom of the viewport and
    // sits over this bar, making it invisible and unclickable while reviewing. Lift ours
    // above it. The selector does not exist on a published theme, so this is a no-op in
    // production. Added 2026-10-15 so the preview is actually reviewable on a phone.
    var liftForPreviewBar = function () {
      var pbar = d.querySelector('#PBarNextFrameWrapper, #preview-bar-iframe');
      if (!pbar) return;
      var h = Math.round(pbar.getBoundingClientRect().height) || 56;
      bar.style.bottom = h + 'px';
    };
    liftForPreviewBar();
    setTimeout(liftForPreviewBar, 1500);
    window.addEventListener('resize', liftForPreviewBar);

    var syncBar = function () {
      var sz = d.querySelector('[data-frt-size-label]');
      var pr = d.querySelector('[data-frt-price]');
      var s = bar.querySelector('[data-frt-sticky-size]');
      var p2 = bar.querySelector('[data-frt-sticky-price]');
      if (sz && s) s.textContent = sz.textContent;
      if (pr && p2) p2.textContent = pr.textContent;
      proxy.disabled = atc.disabled;
      proxy.textContent = atc.disabled ? 'SOLD OUT' : 'ADD TO BAG';
    };
    d.querySelectorAll('[data-frt-size]').forEach(function (r) { r.addEventListener('change', syncBar); });
    syncBar();
  }

  var dr = d.getElementById('frt-sizeguide');
  var sc = d.querySelector('[data-frt-scrim]');
  var opener = d.querySelector('[data-frt-sizeguide-open]');
  if (dr && sc && opener) {
    var last = null;
    var open = function () {
      last = d.activeElement; dr.hidden = false;
      requestAnimationFrame(function () { dr.classList.add('is-open'); sc.classList.add('is-open'); });
      d.body.style.overflow = 'hidden';
      var x = dr.querySelector('[data-frt-sizeguide-close]'); if (x) x.focus();
    };
    var close = function () {
      dr.classList.remove('is-open'); sc.classList.remove('is-open');
      d.body.style.overflow = '';
      setTimeout(function () { dr.hidden = true; }, 300);
      if (last) last.focus();
    };
    opener.addEventListener('click', open);
    var xb = dr.querySelector('[data-frt-sizeguide-close]');
    if (xb) xb.addEventListener('click', close);
    sc.addEventListener('click', close);
    d.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !dr.hidden) close(); });
  }
})();
